import LogoArea, { LogoElement } from "../LogoArea/LogoArea";

import { JSX } from "react";
import { useTranslation } from "react-i18next";

import { Box, Link, Typography } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Container from "@mui/material/Container";

export function Header(): JSX.Element {
  const { t } = useTranslation();
  const logoArea: LogoElement[] = [
    {
      logoSrc: "/asecos-logo.png",
      imgSx: {
        backgroundColor: "primary.main",
        padding: "0rem 0.5rem 0rem 0.5rem",
      },
      onClick: () => {
        console.log("navigate to home page");
        return;
      },
    },
  ];

  return (
    <AppBar
      elevation={0}
      position="sticky"
      color="inherit"
      sx={{
        padding: "0 0px 16px",
        paddingTop: "0",
        borderBottom: "1px solid",
        borderColor: "text.disabled",
      }}
    >
      <Container maxWidth="xl">
        <Box display="flex" alignItems="center">
          <Box mr="auto" display="flex" gap={2}>
            <LogoArea logoArea={logoArea} />
            <Typography
              variant="h1"
              component={"h1"}
              color="secondary"
              sx={{
                mt: "auto",
                fontWeight: "300",
              }}
            >
              {t("AS:header.configurator.title")}
            </Typography>
          </Box>
          <Box
            ml={2}
            alignItems="flex-end"
            display="flex"
            flexDirection="column"
            alignSelf="flex-end"
          >
            <Link
              variant="body2"
              href={t("AS:header.links.about.url")}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              color="primary.main"
              sx={{ fontWeight: 400 }}
            >
              {t("AS:header.links.about.label")}
            </Link>
            <Link
              variant="body2"
              href={t("AS:header.links.terms.url")}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              color="primary.main"
              sx={{ fontWeight: 400 }}
            >
              {t("AS:header.links.terms.label")}
            </Link>
            <Link
              variant="body2"
              href={t("AS:header.links.imprint.url")}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              color="primary.main"
              sx={{ fontWeight: 400 }}
            >
              {t("AS:header.links.imprint.label")}
            </Link>
            <Link
              variant="body2"
              href={t("AS:header.links.privacy.url")}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              color="primary.main"
              sx={{ fontWeight: 400 }}
            >
              {t("AS:header.links.privacy.label")}
            </Link>
          </Box>
        </Box>
      </Container>
    </AppBar>
  );
}
